/**
 * @module CartButton
 * @description
 */
import { useContext } from "react";
import { FuelContext } from "@/providers/fuel-provider";
import Link from "next/link";
import { trackEvent } from "@/js/helpers/tracking";
import styles from "./DynamicButton.module.css";

/**
 * @function CartButton
 * @description
 */
export const CartButton = ({ ...props }) => {
  const { clickThrough } = useContext(FuelContext);
  const { href = clickThrough, location, position, title } = props;

  /**
   * @function handleClick
   * @description
   */
  const handleClick = (event) => {
    const data = {
      elementType: "BUTTON",
      position,
      location,
      text: title || "Check Availability",
      actionOutcome: "INTERNALLINK",
    };

    trackEvent({ action: "elementClicked", data, event });
  };

  return (
    <Link
      href={href}
      onClick={handleClick}
      data-type="cart"
      className={`btn ${styles.component__btn}`}
      {...props}
    >
      {title || "Check Availability"}
    </Link>
  );
};

export default CartButton;
